import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { rgba } from "polished";

import { Button, Flex, Modal as AntdModal, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const props = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    centered: PropTypes.bool,
    closable: PropTypes.bool,
    width: PropTypes.number,
    contentStyle: PropTypes.object,
};

const Modal = ({ open, onClose, title, children, centered, closable, width, contentStyle }) => {
    return (
        <Wrapper
            open={open}
            onCancel={onClose}
            maskClosable={closable !== undefined ? closable : true}
            closeIcon={null}
            footer={null}
            centered={centered || false}
            width={width || 520}
        >
            <Flex className="title" justify="space-between" align="center">
                <Typography.Title level={5} className="mt-0 mb-0" type="secondary">
                    {title}
                </Typography.Title>
                <Button
                    className="close-modal"
                    type="primary"
                    shape="circle"
                    icon={<CloseOutlined />}
                    size="small"
                    onClick={onClose}
                />
            </Flex>
            <div className="content" style={contentStyle || {}}>
                {children}
            </div>
        </Wrapper>
    );
};

const Wrapper = styled(AntdModal)`
    .ant-modal-content {
        padding: 0;

        .title {
            padding: 15px 20px;

            border-radius: 6px 6px 0 0;

            background-color: ${(props) => rgba(props.theme.orange, 0.25)};
        }

        .content {
            padding: 20px;
        }
    }
`;

Modal.propTypes = props;

export default Modal;
